// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VersionComparisonStatistics
 */
export interface VersionComparisonStatistics {
    /**
     * 
     * @type {number}
     * @memberof VersionComparisonStatistics
     */
    fields_changed?: number;
    /**
     * 
     * @type {number}
     * @memberof VersionComparisonStatistics
     */
    sections_added?: number;
    /**
     * 
     * @type {number}
     * @memberof VersionComparisonStatistics
     */
    sections_deleted?: number;
}

/**
 * Check if a given object implements the VersionComparisonStatistics interface.
 */
export function instanceOfVersionComparisonStatistics(value: object): value is VersionComparisonStatistics {
    return true;
}

export function VersionComparisonStatisticsFromJSON(json: any): VersionComparisonStatistics {
    return VersionComparisonStatisticsFromJSONTyped(json, false);
}

export function VersionComparisonStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VersionComparisonStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'fields_changed': json['fields_changed'] == null ? undefined : json['fields_changed'],
        'sections_added': json['sections_added'] == null ? undefined : json['sections_added'],
        'sections_deleted': json['sections_deleted'] == null ? undefined : json['sections_deleted'],
    };
}

export function VersionComparisonStatisticsToJSON(json: any): VersionComparisonStatistics {
    return VersionComparisonStatisticsToJSONTyped(json, false);
}

export function VersionComparisonStatisticsToJSONTyped(value?: VersionComparisonStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fields_changed': value['fields_changed'],
        'sections_added': value['sections_added'],
        'sections_deleted': value['sections_deleted'],
    };
}
